import React, {Component} from 'react';
import axios from 'axios'
import * as config from '../../../config';
import PropTypes from 'prop-types';

import Spinner from '../../Shared/Spinner';

class ReportByFile extends Component {
    constructor(props){
        super(props)

        this.state = {
            fetching:false,
            error:false,
            errorText:""
        }
    }
    handleFileChange(e){

        this.setState({
            fetching:true
        })

        let file =e.target.files[0];

        if(!file && this.state.fetching) return null;

        let data  = new FormData();
        data.append("file",file)
        data.append("ReportId",this.props.ReportId)
        axios.post(
            config.apiUrl + "/offers/getreportbyofferlist",
            data,
            {
                headers: {
                   // 'Content-Type': 'multipart/form-data'
                },
            }
        ).then((response)=>{
            this.setState({
                    fetching:false,
                    error:false,
                    errorText:""
                },()=>{
                    this.file.value=""
                }
            )
        }).catch((error)=>{
            this.setState({
                fetching:false,
                error:true
            })
        })
    }
    handleClick(e){
        if(this.state.fetching){
            e.stopPropagation();
            e.preventDefault();
        }
    }

    render() {
        return (
            <div className="form-group">
                <label>Запустить формирование отчета по файлу с артикулами: </label>
                <div className="uploader">
                    <input type="file" className="file-styled" onClick={(e)=>{this.handleClick(e)}} onChange={(e)=>this.handleFileChange(e)} ref={(input)=>this.file = input}/>
                    <span className="filename" >
                         {
                             this.state.fetching ?
                                 <Spinner
                                     styles={{
                                         backgroundColor: "#37474F"
                                     }}
                                 />
                                 : null
                         }
                    </span>
                    <span className="action btn btn-default" >Выберите файл</span>
                </div>
            </div>
        );
    }
}

ReportByFile.propTypes = {
    ReportId:PropTypes.number.isRequired
};
ReportByFile.defaultProps = {};


export default ReportByFile;





// WEBPACK FOOTER //
// ./src/components/Admin/Report/ReportByFile.jsx